import { render, staticRenderFns } from "./TillContent.vue?vue&type=template&id=c2fea9f4&scoped=true"
import script from "./TillContent.vue?vue&type=script&lang=js"
export * from "./TillContent.vue?vue&type=script&lang=js"
import style0 from "./TillContent.vue?vue&type=style&index=0&id=c2fea9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fea9f4",
  null
  
)

export default component.exports